import { render, staticRenderFns } from "./SettingNotification.vue?vue&type=template&id=3958a1f8"
import script from "./SettingNotification.vue?vue&type=script&lang=js"
export * from "./SettingNotification.vue?vue&type=script&lang=js"
import style0 from "./SettingNotification.vue?vue&type=style&index=0&id=3958a1f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports